import { render, staticRenderFns } from "./transactions.vue?vue&type=template&id=54dfec12&scoped=true&"
import script from "./transactions.vue?vue&type=script&lang=js&"
export * from "./transactions.vue?vue&type=script&lang=js&"
import style0 from "./transactions.vue?vue&type=style&index=0&id=54dfec12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dfec12",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54dfec12')) {
      api.createRecord('54dfec12', component.options)
    } else {
      api.reload('54dfec12', component.options)
    }
    module.hot.accept("./transactions.vue?vue&type=template&id=54dfec12&scoped=true&", function () {
      api.rerender('54dfec12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pages/analytics/transactions.vue"
export default component.exports